<template>
  <div class="open-time">
    <h1 class="m-font-1">交通路线</h1>
    <div class="open-content">
      <div class="mb-72">
        <div class="mb-40">
          <div class="date mb-10">
            <img src="../../assets/images/icon_public@2x.png" alt="">
            <span>公共交通路线</span>
          </div>
          <div class="close" style="margin-left: 55px;">沈阳市浑南区智慧三街157号</div>
        </div>
        <div class="pic">
          <img src="../../assets/images/map_public@2x.png" alt="">
        </div>
        <div class="box">
          <div class="box_inner" style="margin-right: 40px;">
            <h2>地铁</h2>
            <p><span class="line"></span>乘坐地铁2号线至省博物馆站，从 D 出口出站步行150米到达辽宁省博物馆</p>
            <!-- <p><span class="line"></span>乘坐地铁二号线至世纪大厦站，换乘有轨电车三号线或四号线至和鸿广场站，再西行500米到达辽宁省博物馆</p> -->
          </div>

          <div class="box_inner">
            <h2>公交</h2>
            <p><span class="line"></span>乘坐130路、108路、100路、198北环、305路或V111路公交车至智慧四街全运三路公交站，步行500米到达辽宁省博物馆</p>
            <p><span class="line"></span>乘坐128路公交车至全运三路智慧四街/智慧四街全运二路公交站，步行700米到达辽宁省博物馆</p>
          </div>
        </div>
      </div>

      <div>
        <div class="date mb-40" >
          <img class="park" src="../../assets/images/icon_Parking lot@2x.png" alt="">
          <span>停车场</span>
        </div>
        <div class="pic">
          <img src="../../assets/images/map_Parking lot@2x.png" alt="">
        </div>
        <div class="box">
          <div class="box_inner" style="margin-right: 40px;">
            <h2>辽宁省博物馆停车场</h2>
            <p><span class="line"></span>停车场入口位于辽宁省博物馆南侧，共有停车位57个</p>
          </div>

          <div class="box_inner">
            <h2>浑南新城中央公园地下停车场</h2>
            <p><span class="line"></span>地下停车场入口位于浑南新城中央公园，距离辽宁省博物馆300米，共有停车位1776个</p>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {

  data() {
    return {
      dataList: []
    };
  },

  mounted() {
    // this.getData()
  },

  methods: {
    // getData() {
    //   this.$http
    //     .get('../singleMuseum/webapi/zqdy')
    //     .then(res => {
    //       if (res.success) {
    //         this.dataList = res.data
    //         console.log(dataList)
    //       } else {
    //         this.$message.error(res.message)
    //       }
    //     })
    // }
  },
};
</script>

<style lang="scss" scoped>
.open-time {
  width: 100%;
  h1 {
    margin-bottom: 60px;
    // font-size: 44px;
    font-weight: 400;
    color: #000000;
  }
  // .pl-20 {
  //   padding-left: 20px;
  // }

  .open-content {
    .mb-72{
      margin-bottom: 72px;
    }
    .date {
      font-size: 22px;
      margin-bottom: 20px;
      font-weight: 400;
      color: #000000;
      display: flex;
      align-items: center;
      img {
        width: 33px;
        height: 31px;
        margin-right: 24px;
        &.park {
          width: 28px;
          height: 36px;
        }
      }
    }

    .week,
    .close {
      font-size: 16px;
      font-weight: 400;
      color: #000000;
    }

    .pic {
      height: 666px;
      background: #e5e4e0;
      text-align: center;
      margin-bottom: 40px;
      img {
        height: 100%;
      }
    }

    .box {
      display: flex;
      .box_inner {
        flex: 1;
        border: 1px solid rgba($color: #312f2e, $alpha: 0.2);
        padding: 20px;
        border-radius: 5px;
      }
      h2 {
        font-size: 22px;
        font-weight: 400;
        color: #ae8148;
        margin-bottom: 20px;
      }

      p {
        color: #010101;
        font-size: 16px;
        line-height: 38px;

        .line {
          display: inline-block;
          background: #ae8148;
          position: relative;
          top: 2px;
          width: 3px;
          margin-right: 8px;
          height: 16px;
        }
      }
    }

    .close {
      display: flex;
      align-items: center;
      &::before {
        content: '';
        display: block;
        background: #ae8148;
        position: relative;
        top: 1px;
        width: 3px;
        height: 17px;
        margin-right: 9px;
      }
    }
  }
}
</style>